module.exports = __webpack_public_path__ + "media/images/icons/consultation-03-c220de5d1b1a2cf31abf22333215945e.svg";